export default "__VITE_ASSET__CECVz8Ni__"